import { http } from "./http";

/**
 * Monta query string só com chaves definidas (evita enviar undefined como "undefined").
 */
function buildParams(filters = {}) {
  const params = {};
  if (filters.limit != null && filters.limit !== "") {
    params.limit = filters.limit;
  }
  if (filters.fromDeletedAt) {
    params.fromDeletedAt = filters.fromDeletedAt;
  }
  if (filters.toDeletedAt) {
    params.toDeletedAt = filters.toDeletedAt;
  }
  if (filters.title != null && String(filters.title).trim() !== "") {
    params.title = String(filters.title).trim();
  }
  if (filters.responsibleId != null && String(filters.responsibleId).trim() !== "") {
    params.responsibleId = String(filters.responsibleId).trim();
  }
  if (filters.deletedBy != null && String(filters.deletedBy).trim() !== "") {
    params.deletedBy = String(filters.deletedBy).trim();
  }
  if (filters.opportunityId != null && String(filters.opportunityId).trim() !== "") {
    params.opportunityId = String(filters.opportunityId).trim();
  }
  return params;
}

/**
 * Oportunidades com última revisão Envers = exclusão (DEL).
 * Requer cabeçalhos de tenant (X-Company-Id, etc. via interceptor).
 *
 * Filtros opcionais: limit, fromDeletedAt, toDeletedAt (ISO-8601), title, responsibleId, deletedBy
 */
export async function fetchDeletedOpportunities(companyId, filters = {}) {
  const { data } = await http.get("/api/sales/opportunities/deleted-records", {
    headers: { "X-Company-Id": String(companyId) },
    params: buildParams(filters),
  });
  return Array.isArray(data) ? data : [];
}

/**
 * Tarefas com última revisão Envers = exclusão (DEL).
 * Filtros opcionais: os de oportunidades + opportunityId
 */
export async function fetchDeletedTasks(companyId, filters = {}) {
  const { data } = await http.get("/api/sales/tasks/deleted-records", {
    headers: { "X-Company-Id": String(companyId) },
    params: buildParams(filters),
  });
  return Array.isArray(data) ? data : [];
}

/**
 * Usuários da empresa (IAM) para enriquecer responsibleId -> nome.
 */
export async function fetchCompanyUsers(companyId) {
  const { data } = await http.get(`/crm/iam/companies/${companyId}/users`, {
    headers: { "X-Company-Id": String(companyId) },
  });
  return Array.isArray(data) ? data : [];
}

/** @deprecated Use fetchDeletedOpportunities + fetchDeletedTasks */
export async function fetchDeletedRecords(companyId, { limit } = {}) {
  const [opportunities, tasks] = await Promise.all([
    fetchDeletedOpportunities(companyId, { limit }),
    fetchDeletedTasks(companyId, { limit }),
  ]);
  return { opportunities, tasks };
}

export async function restoreOpportunity(companyId, opportunityId) {
  const { data } = await http.post(
    `/api/sales/opportunities/${opportunityId}/restore`,
    null,
    {
      headers: { "X-Company-Id": String(companyId) },
    }
  );
  return data;
}
